import React from 'react';
import * as Sentry from '@sentry/react';
import { noop } from '../utils/common';

export interface CurrentUser {
  id: string | number;
  email: string;
  first_name: string;
  last_name: string;
  is_admin: boolean;
  is_super_admin: boolean;
  language: string;
  translation_language?: string | null;
  type: string;
  workspace_id: string | number;
  otp_2fa_enabled?: boolean;
  workspace: {
    id: string | number;
    name: string;
    config: {
      featureflags: string[];
      available_platforms?: string[];
      available_case_types?: string[];
      keywords_parser_class?: string;
      };
  };

}

export const CurrentUserContext = React.createContext<
  [CurrentUser | null, (currentUser: CurrentUser) => void]
>([null, noop]);

export const useCurrentUser = () => React.useContext(CurrentUserContext);

export const CurrentUserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const value = React.useState<CurrentUser | null>(null);
  const [currentUser] = value;

  React.useEffect(() => {
    if (currentUser) {
      Sentry.setUser({ id: String(currentUser.id) });
      Sentry.setTag('workspace_id', String(currentUser.workspace_id));
    } else {
      Sentry.setUser(null);
      Sentry.setTag('workspace_id', undefined);
    }
  }, [currentUser]);

  return (
    <CurrentUserContext.Provider value={value}>
      {children}
    </CurrentUserContext.Provider>
  );
};
